import React, { useCallback } from 'react';
import { useIntersectionObserver } from '@rexlabs/react-hooks';
export function Observer(_ref) {
  var root = _ref.root,
      setIntersecting = _ref.setIntersecting;
  var intersectionObserverCallback = useCallback(function (entry) {
    setIntersecting(function (prevIsIntersecting) {
      var rootBounds = entry.rootBounds,
          boundingClientRect = entry.boundingClientRect,
          intersectionRatio = entry.intersectionRatio,
          isIntersecting = entry.isIntersecting; // The intersection observer sometimes fires when it
      // shouldn't so this makes sure we don't set shadows
      // when we haven't scrolled

      if (intersectionRatio === 0) {
        if (boundingClientRect.top === rootBounds.top || boundingClientRect.right === rootBounds.right || boundingClientRect.bottom === rootBounds.bottom || boundingClientRect.left === rootBounds.left) {
          return prevIsIntersecting;
        }
      }

      return isIntersecting;
    });
  }, [setIntersecting]);
  var observerRef = useIntersectionObserver(intersectionObserverCallback, {
    root: root
  });
  return /*#__PURE__*/React.createElement("span", {
    ref: observerRef
  });
}